import AddClient from "../components/AddClient";
import Breadcrumb from "../components/Breadcrumb";

const AddClientPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Add Client" />

      {/* AddClientLayer */}
      <AddClient />
    </>
  );
};

export default AddClientPage;
